export const roleOptions = [
  { value: '', label: 'Все' },
  { value: 'true', label: 'Резидент ОЭЗ' },
  { value: 'false', label: 'Нерезидент ОЭЗ' },
];
